import campaignService from '../services/campaignService'

export const CAMPAIGN_LIST_REQUEST = '@campaign/list-request'
export const CAMPAIGN_LIST_SUCCESS = '@campaign/list-success'
export const CAMPAIGN_LIST_FAIL = '@campaign/list-fail'


export const CAMPAIGN_REQUEST = '@campaign/campain-request'
export const CAMPAIGN_REQUEST_SUCCESS = '@campaign/campain-request-success'
export const CAMPAIGN_REQUEST_FAIL = '@campaign/campain-request-fail'

export const ADD_NEW_QUESTION_PAGES = '@campaign/@questionPages/add-new';

export const CAMPAIGN_ADD_LEADTYPE = '@campaign/@leadtype/add'

export function getCampaignList(active, page, itemsPerPage) {
    return async dispatch => {
        try {
            dispatch({
                type: CAMPAIGN_LIST_REQUEST,
            })


            const response = await campaignService.getList(active, page, itemsPerPage)

            dispatch({
                type: CAMPAIGN_LIST_SUCCESS,
                payload: response
            })
        } catch (error) {
            dispatch({ type: CAMPAIGN_LIST_FAIL })
            throw error
        }
    }
}

export function getCampaign(campaignId, timeRange) {
    return async dispatch => {
        try {
            dispatch({
                type: CAMPAIGN_REQUEST,
                loading: true,
            })
            const campaign = await campaignService.get(campaignId, timeRange)
            dispatch({
                type: CAMPAIGN_REQUEST_SUCCESS,
                payload: {
                    campaign,
                }
            })
        } catch (error) {
            dispatch({ type: CAMPAIGN_REQUEST_FAIL })
            throw error
        }
    }
}

export const addNewLeadTypes = (payload) => ({
    type: CAMPAIGN_ADD_LEADTYPE,
    payload
})

export const AddNewQuestionPage = (newQuestionPage) => ({
    type: ADD_NEW_QUESTION_PAGES,
    payload: newQuestionPage,
})
